import React, { memo } from 'react';
import { Skeleton } from 'site-modules/shared/components/skeleton/skeleton';

import './answer-skeleton.scss';

export const AnswerSkeleton = memo(() => (
  <div className="answer-skeleton base-inner-width pb-0_75 pb-md-1 px-1 px-md-0_5 px-lg-0 mx-md-auto">
    <Skeleton className="d-block height-22 rounded-6 w-100 mb-0_5" />
    <Skeleton className="d-block height-22 rounded-6 w-100 mb-0_5" />
    <Skeleton className="d-block height-22 rounded-6 w-40 mb-0_5" />
  </div>
));

AnswerSkeleton.displayName = 'AnswerSkeleton';
